import React, { useState } from 'react';
import { ThemeProvider } from '@emotion/react';
import { BrowserRouter as Router } from 'react-router-dom';
import GlobalStyles from './styles';
import theme from './styles/themes/standard';
import history from './routing/history';
import { AuthProvider } from './hooks/useAuth';
import { EntryContext } from './hooks/useEntry';
import { CrossSellBarContainer } from './components/CrossSellBar';
import { NavbarContainer } from './components/Navbar';
import { ApplicationRoutes } from './routing/ApplicationRoutes';
import { AuthRefresh } from './components/Auth/Refresh';
import { SweepContext } from './hooks/useSweep';
import { ErrorContext } from './hooks/useError';
import { FeaturesProvider } from './hooks/useFeatures';
import ScrollToTop from './routing/ScrollToTop';
import { CookieConsentProvider } from './hooks/useCookieConsents';
import { isPick7iOSWebView } from './utils/authUtils';

function App() {
    const [sweep, setSweep] = useState({
        sweepId: null,
        name: '-',
        prize: '-',
        date: '-',
        event: {}
    });

    const [entry, setEntry] = useState({
        id: null,
        name: null,
        metaData: {},
        hasEntered: false
    });

    const [error, setError] = useState(null);

    return (
        <CookieConsentProvider>
            <AuthProvider>
                <AuthRefresh>
                    <FeaturesProvider>
                        <SweepContext.Provider value={{ sweep, setSweep }}>
                            <EntryContext.Provider value={{ entry, setEntry }}>
                                <ErrorContext.Provider
                                    value={{ error, setError }}
                                >
                                    <ThemeProvider theme={theme}>
                                        <GlobalStyles />
                                        <Router history={history}>
                                            <CrossSellBarContainer />
                                            {!isPick7iOSWebView() && (
                                                <NavbarContainer />
                                            )}
                                            <ScrollToTop>
                                                <ApplicationRoutes />
                                            </ScrollToTop>
                                        </Router>
                                    </ThemeProvider>
                                </ErrorContext.Provider>
                            </EntryContext.Provider>
                        </SweepContext.Provider>
                    </FeaturesProvider>
                </AuthRefresh>
            </AuthProvider>
        </CookieConsentProvider>
    );
}

export default App;
